import '../scss/frontend.scss';
import { initAppHeight, observeVisibility } from './parts/helpers';
import { fadeOutPreloader, initScrollHeader, initScrollTop } from './parts/general';
import { initMobileMenu } from './parts/mobile-menu';
import { initGradientHighlights, initGradientTitleLines } from './parts/highlight-sweep';
const onReady = () => {
    initAppHeight();
    initScrollHeader();
    initScrollTop();
    initMobileMenu();
    initGradientHighlights();
    initGradientTitleLines();
};
const onLoad = () => {
    document.body.classList.add('loaded');
    fadeOutPreloader();
    observeVisibility('section');
    observeVisibility('.animate__fadeIn, .animate__fadeInUp, .animate__fadeInDown, .animate__fadeInLeft, .animate__fadeInRight', 'animate__animated', 0.3, false);
};
document.addEventListener('DOMContentLoaded', onReady);
window.addEventListener('load', onLoad);
